/**
 * Privacy Policy Page
 */

import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

export function PrivacyPolicyPage() {
  return (
    <div className="container py-8 max-w-4xl">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6"
      >
        <ArrowLeft size={18} />
        홈으로 이동
      </Link>

      <div className="bg-white rounded-xl border p-8">
        <div className="flex items-center gap-3 mb-6">
          <Shield className="text-orange-500" size={28} />
          <h1 className="text-2xl font-bold text-gray-900">개인정보처리방침</h1>
        </div>

        <p className="text-sm text-gray-500 mb-8">
          최종 수정일: 2026년 2월 22일
        </p>

        <div className="prose prose-gray max-w-none">
          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">1. 개인정보 수집</h2>
            <p className="text-gray-600">
              moapc.com(이하 "본 사이트")는 서비스 제공을 위해 최소한의 개인정보만을 수집합니다.
              현재 본 사이트는 회원가입 기능을 제공하지 않으며, 개인정보를 직접 수집하지 않습니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">2. 쿠키 사용</h2>
            <p className="text-gray-600">
              본 사이트는 사용자 경험 개선과 트래픽 분석을 위해 쿠키를 사용할 수 있습니다.
              브라우저 설정을 통해 쿠키를 차단할 수 있습니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">3. 제3자 서비스</h2>
            <p className="text-gray-600">
              본 사이트는 AliExpress, Coupang 등의 제휴사와 연결됩니다.
              제휴사 링크를 클릭하면 해당 사이트의 개인정보처리방침이 적용됩니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">4. 로그 데이터</h2>
            <p className="text-gray-600">
              본 사이트는 서비스 품질 향상을 위해 접속 로그, 브라우저 정보 등을
              익명으로 수집할 수 있습니다.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">5. 연락처</h2>
            <p className="text-gray-600">
              개인정보 관련 문의사항은 이메일로 연락 주시기 바랍니다.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
